import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const ManagerNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='manager' />

export default ManagerNavItem